/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { UpdateRunClubEventDistanceDto } from './update-run-club-event-distance-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { UpdateRunClubEventPaceGroupDto } from './update-run-club-event-pace-group-dto';

/**
 * 
 * @export
 * @interface UpdateRunClubEventDto
 */
export interface UpdateRunClubEventDto {
    /**
     * Event title
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'title'?: string;
    /**
     * Event description
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'description'?: string;
    /**
     * Cover photo URL
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'coverPhotoUrl'?: string;
    /**
     * Array of additional image URLs
     * @type {Array<string>}
     * @memberof UpdateRunClubEventDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Assembly time in UTC
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'assemblyAt'?: string;
    /**
     * Start time in UTC
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'startAt'?: string;
    /**
     * End time in UTC
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'endAt'?: string;
    /**
     * IANA timezone
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'timezone'?: string;
    /**
     * Country code ISO-3166-1 alpha-2
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'countryCode'?: string;
    /**
     * Country name snapshot
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'countryName'?: string;
    /**
     * Province code (PSGC/ISO-3166-2)
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'provinceCode'?: string;
    /**
     * Province name snapshot
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'provinceName'?: string;
    /**
     * City/Municipality code (PSGC)
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'cityCode'?: string;
    /**
     * City/Municipality name snapshot
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'cityName'?: string;
    /**
     * Barangay code (PSGC)
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'barangayCode'?: string;
    /**
     * Barangay name snapshot
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'barangayName'?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'postalCode'?: string;
    /**
     * Street
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'street'?: string;
    /**
     * Landmark
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'landmark'?: string;
    /**
     * Latitude
     * @type {number}
     * @memberof UpdateRunClubEventDto
     */
    'latitude'?: number;
    /**
     * Longitude
     * @type {number}
     * @memberof UpdateRunClubEventDto
     */
    'longitude'?: number;
    /**
     * Place ID reference
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'placeId'?: string;
    /**
     * Maximum participants
     * @type {number}
     * @memberof UpdateRunClubEventDto
     */
    'maxParticipants'?: number;
    /**
     * Event visibility
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'visibility'?: UpdateRunClubEventDtoVisibilityEnum;
    /**
     * Event status
     * @type {string}
     * @memberof UpdateRunClubEventDto
     */
    'status'?: UpdateRunClubEventDtoStatusEnum;
    /**
     * Participation fee amount
     * @type {number}
     * @memberof UpdateRunClubEventDto
     */
    'feeAmount'?: number;
    /**
     * Event distances (update/add/delete via id/isDeleted)
     * @type {Array<UpdateRunClubEventDistanceDto>}
     * @memberof UpdateRunClubEventDto
     */
    'distances'?: Array<UpdateRunClubEventDistanceDto>;
    /**
     * Event pace groups (update/add/delete via id/isDeleted)
     * @type {Array<UpdateRunClubEventPaceGroupDto>}
     * @memberof UpdateRunClubEventDto
     */
    'paceGroups'?: Array<UpdateRunClubEventPaceGroupDto>;
}

export const UpdateRunClubEventDtoVisibilityEnum = {
    Public: 'public',
    Unlisted: 'unlisted',
    Private: 'private'
} as const;

export type UpdateRunClubEventDtoVisibilityEnum = typeof UpdateRunClubEventDtoVisibilityEnum[keyof typeof UpdateRunClubEventDtoVisibilityEnum];
export const UpdateRunClubEventDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Cancelled: 'cancelled'
} as const;

export type UpdateRunClubEventDtoStatusEnum = typeof UpdateRunClubEventDtoStatusEnum[keyof typeof UpdateRunClubEventDtoStatusEnum];


